const padBefore = (str, len = 2, padding = '0') =>
  `${(new Array(len)).fill(padding).join('')}${str}`.slice(-len);

export default padBefore;